import { LegalPage } from "@/components/legal/legal-page";
import { SellerDetailsList, SellerEmail } from "@/components/legal/seller-details";

/**
 * Kontaktai — /kontaktai, public, for the reason the terms are: the seller's
 * details have to be on the site (Elektroninės komercijos įstatymo 5 str.),
 * readable before anybody has an account. The values come from `lib/seller.ts`.
 */
export default function ContactsPage() {
  return (
    <LegalPage title="Kontaktai">
      <section>
        <p>Scio paslaugą teikia ir parduoda:</p>
        <div className="mt-4">
          <SellerDetailsList />
        </div>
      </section>

      <section>
        <p>
          Klausimus apie programą, prenumeratą ar jūsų duomenis siųskite adresu{" "}
          <SellerEmail />.
        </p>
      </section>
    </LegalPage>
  );
}
